import { FaChevronLeft, FaChevronRight, FaSearchPlus } from 'react-icons/fa';
import { FaArrowLeft, FaArrowRight, FaHandHoldingUsd, FaPiggyBank } from 'react-icons/fa';
import { IoLogoAndroid, IoMdClose, IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { FaChevronDown, FaInstagram, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
import { FaChevronUp } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import { FaRegPlusSquare } from 'react-icons/fa';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { FaTv } from 'react-icons/fa';
import { RxCross2 } from 'react-icons/rx';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { BiLoaderCircle } from 'react-icons/bi';
import { FaHandPointDown } from 'react-icons/fa';
import { FaSignInAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { VscTriangleDown } from 'react-icons/vsc';
import { FiCalendar } from 'react-icons/fi';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import {
  IoChevronBackSharp,
  IoChevronForwardSharp,
  IoDiceOutline,
  IoWalletOutline,
} from 'react-icons/io5';
import { RiBankFill } from 'react-icons/ri';
import { FaTrophy } from 'react-icons/fa';
import { FaBook, FaGift, FaPlay, FaUserPlus } from 'react-icons/fa';
import {
  FiActivity,
  FiBookOpen,
  FiCheck,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
  FiClock,
  FiCopy,
  FiFileText,
  FiGift,
  FiInbox,
  FiList,
  FiMoon,
  FiPlus,
  FiRepeat,
  FiSearch,
  FiShield,
  FiSun,
  FiUser,
  FiLogOut,
} from 'react-icons/fi';
import { MdContentPaste, MdQrCode2, MdSportsBaseball, MdSportsRugby } from 'react-icons/md';
import { SiGooglepay, SiPhonepe, SiTether } from 'react-icons/si';
import { BsLightningChargeFill } from 'react-icons/bs';
export const Icons = {
  Trophy: FaTrophy,
  Baseball: MdSportsBaseball,
  Rugby: MdSportsRugby,
  Android: IoLogoAndroid,
  SearchPlus: FaSearchPlus,
  Search: FiSearch,
  User: FiUser,
  Rules: FiBookOpen,
  Sun: FiSun,
  Gift: FiGift,
  Shield: FiShield,
  Statement: FiFileText,
  Activity: FiActivity,
  BetList: FiList,
  Dice: IoDiceOutline,
  Inbox: FiInbox,
  Check: FiCheck,
  ChevronDown: FiChevronDown,
  PageFirst: FiChevronsLeft,
  PagePrev: FiChevronLeft,
  PageNext: FiChevronRight,
  PageLast: FiChevronsRight,
  Moon: FiMoon,
  Down: FaChevronDown,
  Up: FaChevronUp,
  Menu: FaBars,
  PlusSquare: FaRegPlusSquare,
  MinusSquare: AiOutlineMinusSquare,
  Close: IoIosCloseCircleOutline,
  Tv: FaTv,
  Cross: RxCross2,
  Eye: FaEye,
  EyeSlash: FaEyeSlash,
  Home: FaHome,
  Loading: BiLoaderCircle,
  PointDown: FaHandPointDown,
  SignIn: FaSignInAlt,
  Lock: FaLock,
  TriangleDown: VscTriangleDown,
  Calendar: FiCalendar,
  Back: FaChevronLeft,
  Forward: FaChevronRight,
  calendar: MdOutlineCalendarMonth,
  chevronBack: IoChevronBackSharp,
  chevronForward: IoChevronForwardSharp,
  openEye: IoMdEye,
  closeEye: IoMdEyeOff,
  previous: FaArrowLeft,
  next: FaArrowRight,
  close: IoMdClose,
  wallet: IoWalletOutline,
  bank: RiBankFill,
  deposit: FaPiggyBank,
  withdraw: FaHandHoldingUsd,
  qr: MdQrCode2,
  tether: SiTether,
  googlePay: SiGooglepay,
  phonePe: SiPhonepe,
  clock: FiClock,
  instagram: FaInstagram,
  whatsapp: FaWhatsapp,
  telegram: FaTelegramPlane,
  transactions: FiRepeat,
  instant: BsLightningChargeFill,
  paste: MdContentPaste,
  copy: FiCopy,
  plus: FiPlus,
  logout: FiLogOut,
  play: FaPlay,
  offers: FaGift,
  referral: FaUserPlus,
  passbook: FaBook,
};
